import React, { useState, useEffect } from "react";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import RequestService from "../../services/RequestService";
import BoardingService from "../../services/BoardingService";
import DocumentoService from "../../services/DocumentoService";
import { parseISO, format } from "date-fns";
import StatusRequests from '../../enums/StatusRequests'
import { MdSend } from "react-icons/md";
import MinorRequestDetails from './../molecules/MinorRequestDetails';

export default function BoardingModal({
  isModalOpen,
  setModalOpen,
  requestId,
  requestNro
  // setTicketCb
}) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const [requestObject, setRequestObject] = useState();
  const [boardingObject, setBoardingObject] = useState()

  useEffect(() => {
    async function fetchRequest() {
      const request = await RequestService.getRequestById(requestId);
      setRequestObject(request);

      const boardingObj = await BoardingService.getBoardingByRequest(requestId)
      setBoardingObject(boardingObj)

    }

    fetchRequest();
  }, [isModalOpen, requestId]);

  const onSubmit = async (data) => {

    const response = await BoardingService.createBoarding(requestId, data);

    if (response) {
      toast.success("Nota de Embarque gerada!");
      const boardingObj = await BoardingService.getBoardingByRequest(requestId)
      // console.log(response.newBoarding)
      // console.log(requestObject.request)
      DocumentoService.baixarNotaEmbarque(requestId)
    } else {
      // console.log(error)
      toast.error("Ops! Algo deu errado");
    }

    setModalOpen(!isModalOpen);
    reset();
  };

  const onClose = () => {
    setModalOpen(!isModalOpen);
    reset();
  };


 

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto py-8"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col max-w-[700px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all" onClick={(e) => e.stopPropagation()}>
              <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex flex-col px-4 pt-4 pb-3 text-left gap-2 bg-gray-800 text-white rounded-t-lg">
                <div className="flex gap-2 items-center text-white text-xl font-bold">
                  <MdSend />
                  GERAR NOTA DE EMBARQUE
                </div>
                <div className="ms-4 flex justify-between">
                  <div className="text-sm">
                    Solicitação nº: {requestObject?.request?.idRequest}
                  </div>
                  <div className="text-sm">
                    {/* Criado em: {requestObject?.request?.createdAt } */}
                    Criado em: {requestObject && format(parseISO(requestObject?.request?.createdAt), 'dd/MM/yy HH:mm')}
                  </div>
                  <div className="flex items-center gap-2">
                    Status:
                    <p  className="text-sm text-black rounded-lg px-2"
                        style={{ backgroundColor: StatusRequests[requestObject?.request?.status]?.cor }}>
                      {requestObject?.request?.status}
                    </p>
                  </div>
                </div>
              </div>

              <MinorRequestDetails request={requestObject?.request} divContato={true} />

              {/* MODAL FORM BEGIN */}

              <div className="flex flex-col mt-6 px-4 text-xs">
                <div className="w-full relative inline-block text-left">
                  <div className="w-full flex flex-col gap-2 px-4">

                    {boardingObject?.boarding?.length === 0 &&
                    <div className="flex flex-col gap-2">

                    <div className="flex flex-col items-start gap-1 w-full">
                      <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">Transportadora:</label>
                      <select
                        defaultValue="amerinode"
                        {...register("transportadora", { validate: (value) => { return value !== "0"; }, })}
                        className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                          ${errors?.transportadora?.type === "validate" ?
                            " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                          }
                          `}
                      >
                        <option value="0" disabled>Escolha uma transportadora</option>
                        <option value="amerinode">Amerinode</option>
                      </select>
                      {errors?.transportadora?.type === "validate" && (
                        <p className="text-red-500 text-xs whitespace-nowrap">
                          Transportadora é obrigatório
                        </p>
                      )}
                    </div>

                    <div className="w-full flex gap-4">
                      <div className="flex flex-col items-start gap-1 w-full">
                        <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">Tipo de Veículo:</label>
                        <select
                          defaultValue="carro"
                          {...register("tipoVeiculo", { validate: (value) => { return value !== "0"; }, })}
                          className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                            ${errors?.tipoVeiculo?.type === "validate" ?
                              " border border-red-500 outline-none ring-0" : "border border-zinc-500 outline-none ring-0"
                            }
                            `}
                        >
                          <option value="0" disabled>Escolha um tipo</option>
                          <option value="carro">Carro</option>
                          <option value="moto">Moto</option>
                        </select>
                        {errors?.tipoVeiculo?.type === "validate" && (
                          <p className="text-red-500 text-xs whitespace-nowrap">
                            Transportadora é obrigatório
                          </p>
                        )}
                      </div>

                      <div className="flex flex-col items-start gap-1 w-full">
                        <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                          Placa do veículo (opcional)
                        </label>
                        <input
                          type="text"
                          {...register("placaVeiculo", {
                            // required: true,
                          })}
                          className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                          ${
                            errors?.placaVeiculo?.type === "required"
                              ? " border border-red-500 outline-none ring-0"
                              : "border border-zinc-500 outline-none ring-0"
                          }
                          `}
                        />
                        {errors?.placaVeiculo?.type === "required" && (
                          <p className="text-red-500 text-xs ms-2">
                            Campo obrigatório
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="w-full flex gap-4">
                      <div className="flex flex-col items-start gap-1 w-full">
                        <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                          Nome do motorista (opcional)
                        </label>
                        <input
                          type="text"
                          {...register("nomeMotorista", {
                            // required: true,
                          })}
                          className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                          ${
                            errors?.nomeMotorista?.type === "required"
                              ? " border border-red-500 outline-none ring-0"
                              : "border border-zinc-500 outline-none ring-0"
                          }
                          `}
                        />
                        {errors?.nomeMotorista?.type === "required" && (
                          <p className="text-red-500 text-xs ms-2">
                            Campo obrigatório
                          </p>
                        )}
                      </div>

                      <div className="flex flex-col items-start gap-1 w-full">
                        <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                          RG do motorista (opcional)
                        </label>
                        <input
                          type="text"
                          {...register("rgMotorista", {
                            // required: true,
                          })}
                          className={`block w-full rounded-2xl px-4 py-1 text-gray-900 shadow-sm placeholder:text-gray-400
                          ${
                            errors?.rgMotorista?.type === "required"
                              ? " border border-red-500 outline-none ring-0"
                              : "border border-zinc-500 outline-none ring-0"
                          }
                          `}
                        />
                        {errors?.rgMotorista?.type === "required" && (
                          <p className="text-red-500 text-xs ms-2">
                            Campo obrigatório
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                        Deseja adicionar uma observação na Nota de Embarque?
                      </label>
                      <textarea
                        {...register("obsEmbarque", {
                          // required: true,
                        })}
                        className={`
                              w-full h-[70px] p-4 bg-white rounded-2xl justify-start items-center inline-flex resize-none 
                              text-neutral-600 text-sm font-normal font-['Work Sans']
                              focus:border focus:border-zinc-800 focus:outline-none focus:ring-0
                              placeholder:text-neutral-400 placeholder:text-sm placeholder:font-normal
                              ${
                                errors?.obsEmbarque?.type ===
                                "required"
                                  ? "border border-red-500 outline-none ring-0"
                                  : "border border-zinc-500 outline-none ring-0"
                              }
                          `}
                        placeholder={"Observação da Nota de Embarque"}
                      ></textarea>
                      {errors?.obsEmbarque?.type === "required" && (
                        <p className="text-red-500 text-xs whitespace-nowrap">
                          Campo obrigatório
                        </p>
                      )}
                    </div>
                    </div>
                    }
                    

                    {boardingObject?.boarding?.length > 0 ?  
                        <button
                            onClick={() => { DocumentoService.baixarNotaEmbarque(requestId) }}
                            className="w-full bg-neutral-500 text-white py-2 px-4 rounded-2xl hover:bg-neutral-600"
                            >
                            Reimprimir
                        </button>
                        :
                        <button
                            onClick={() => handleSubmit(onSubmit)()}
                            className="w-full bg-blue-500 text-white py-2 px-4 rounded-2xl hover:bg-blue-600"
                            >
                            Gerar Nota de Embarque
                        </button>
                    }

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
